// extracted by mini-css-extract-plugin
export default {"widgetContainer":"widgetContainer--GSzO8","microWidget":"microWidget--GSzO8","trustPilotWidget":"trustPilotWidget--GSzO8"};